export type Indent = { readonly kind: 'space'; readonly width: 2 | 4 } | { readonly kind: 'tab' };

export interface FormatOptions {
  readonly mode: 'pretty' | 'minify';
  /** Ignored when `mode` is `minify`. */
  readonly indent: Indent;
  readonly eol: '\n' | '\r\n';
  /**
   * Applies to `pretty` only. `minify` emits exactly one line and never a trailing
   * terminator — a minified document is meant to be pasted, not stored.
   */
  readonly finalNewline: boolean;
}

export const DEFAULT_FORMAT_OPTIONS: FormatOptions = {
  mode: 'pretty',
  indent: { kind: 'space', width: 2 },
  eol: '\n',
  finalNewline: true,
};
